import { render, staticRenderFns } from "./B2CItemCard.vue?vue&type=template&id=471e0270&scoped=true"
import script from "./B2CItemCard.vue?vue&type=script&lang=js"
export * from "./B2CItemCard.vue?vue&type=script&lang=js"
import style0 from "./B2CItemCard.vue?vue&type=style&index=0&id=471e0270&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471e0270",
  null
  
)

export default component.exports